var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.learningPath.url
    ? _c(
        "a",
        {
          directives: [
            {
              name: "track",
              rawName: "v-track:click",
              value: {
                axId: "clicked_level_tag",
                axExtra: {
                  learning_path_id: this.learningPath.id,
                  learning_path_slug: this.learningPath.slug,
                  version_name: this.learningPath.version_name
                }
              },
              expression:
                "{\n    axId: 'clicked_level_tag',\n    axExtra: {\n      learning_path_id: this.learningPath.id,\n      learning_path_slug: this.learningPath.slug,\n      version_name: this.learningPath.version_name,\n    },\n  }",
              arg: "click"
            }
          ],
          staticClass: "learning-path-link",
          attrs: { href: _vm.learningPath.url }
        },
        [
          _c(
            "div",
            {
              class: ["learning-path-badge", { "flat-bottom": _vm.flatBottom }],
              style: {
                "--background-color": _vm.learningPath.background_color,
                "--color": _vm.learningPath.color
              }
            },
            [
              _c("img", {
                staticClass: "icon",
                attrs: {
                  src: _vm.learningPath.level_highlighted_image_url,
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "text" }, [
                _vm._v(
                  _vm._s(_vm.learningPath.title) +
                    " · Level " +
                    _vm._s(_vm.learningPath.level_number)
                )
              ]),
              _vm._v(" "),
              _c("ArrowIcon", { staticClass: "arrow" })
            ],
            1
          )
        ]
      )
    : _c(
        "div",
        {
          class: ["learning-path-badge", { "flat-bottom": _vm.flatBottom }],
          style: {
            "--background-color": _vm.learningPath.background_color,
            "--color": _vm.learningPath.color
          }
        },
        [
          _c("img", {
            staticClass: "icon",
            attrs: {
              src: _vm.learningPath.level_highlighted_image_url,
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "text" }, [
            _vm._v(
              _vm._s(_vm.learningPath.title) +
                " · Level " +
                _vm._s(_vm.learningPath.level_number)
            )
          ])
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }